module.exports = __webpack_public_path__ + "components/flag/static/square/gs-8f24cea9a7b7518673d8a6a293bcd356.svg";